<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="participants">
					<app-heading :title="`${market.name} Participants`">
						<template v-slot:left>
							<app-button v-if="$ravello.can('marketmath.post')"
								class="d-none d-sm-inline-flex"
								color="success"
								small
								outlined
								:to="{ name: 'market-participant', params: { participant: 'new' } }"
							>Add Participant</app-button>
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="participants"
								:headers="headers"
								:total="count"
								:initial-state="tableState"
								:refresh.sync="refresh"
								sort-by="last_name"
								@update="fetchParticipants"
							>
								<template v-slot:actions="{ item }">
									<app-button
										v-if="$ravello.can('marketmath.put')"
										color="secondary"
										:to="{ name: 'market-participant', params: { participant: item._id } }"
										icon="fa-pencil-alt"
										table
									>
										Edit
									</app-button>
									<app-button-confirm
										v-if="$ravello.can('marketmath.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove participant`
											+ ` <b>${item.first_name} ${item.last_name}</b>?`"
										title="Remove Participant"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
					<app-floating-button
						class="d-inline-flex d-sm-none"
						:to="{ name: 'market-participant', params: { participant: 'new' } }"
						color="success"
						icon="fa-plus"
					/>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { filters, search, tableState } from '@/mixins'
import { marketMathTabs } from '@/datasources/tabs'

export default {
	mixins: [filters, search, tableState],
	data() {
		return {
			market: {
				name: '',
			},
			participants: [],
			count: -1,
			refresh: false,
			tabs: [],
			headers: [{
				text: 'First Name',
				value: 'first_name',
				sortable: true,
			}, {
				text: 'Last Name',
				value: 'last_name',
				sortable: true,
			}, {
				text: 'Email',
				value: 'email',
				sortable: true,
			}, {
				text: 'Phone',
				value: 'phone',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			defaultTableSort: 'last_name',
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
	},
	async mounted() {
		this.market = await this.$ravello.graphql('market', this.marketId)
			.fields(['name'])
			.query()

		this.tabs = marketMathTabs(this.marketId)
	},
	methods: {
		async fetchParticipants(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('participants')
				.parent(this.$ravello.graphql('market', this.marketId))
				.fields(['_id', 'first_name', 'last_name', 'email', 'phone'])
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.participants = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('participants')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
